import { cloneDeep, merge } from 'lodash'

import { getString } from '@sigma-frontend-libs/commons'

import { components, isEmpty, labelModes, proxy } from '@/utils'

import render from './render'

export default function(options = {}, params = {}) {
  return {
    name: 'SettingsFields',

    mixins: [
      proxy({
        type: params.type,
        defaultValue: params.defaultValue
      })
    ],

    props: {
      label: {
        type: [ String, Number, Boolean ],
        default: undefined
      },
      description: {
        type: [ String, Number, Boolean ],
        default: undefined
      },

      items: {
        type: Array,
        default: () => {
          return [ {} ]
        }
      },

      cols: {
        type: [ String, Number ],
        default: 1
      },

      dialog: Boolean,
      disabled: Boolean,

      showDescription: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        showDialog: false
      }
    },

    computed: {
      $_label() {
        if (this.label) {
          return getString(this.label)
        }

        return this.getTranslate(`${options.serviceName}.paths.${options.path}`)
      },
      $_description() {
        if (this.description) {
          return getString(this.description)
        }

        return this.getTranslate(`${options.serviceName}.descriptions.${options.path}`)
      },
      $_disabled() {
        return Boolean(this.disabled || isEmpty(this.proxy) && !this.proxyIsChanged || !this.proxyIsChanged || options.loading.update[options.path])
      }
    },

    methods: {
      _inputFilter: params._inputFilter || (value => {
        if (params.type === 'object' || params.type === 'array') {
          return cloneDeep(value)
        }

        return value
      }),
      _outputFilter: params._outputFilter || (value => {
        return value
      }),

      watchValueHandler() {
        this.receiveValue()
      },
      watchProxyHandler() {
        return
      },

      getComponentProps(item) {
        const component = item.component ?? components['text-field']
        const result = {
          value: this.proxy,
          labelMode: labelModes.hidden,
          disabled: options.loading.update[options.path],
          readonly: options.permission === 'read'
        }
        if (item.field) {
          result.label = this.getTranslate(`${options.serviceName}.labels.${options.path}.${item.field}`)
          result.value = this.proxy[item.field]
        }
        switch (component) {
          case components.switch: {
            let switchLabelKey
            if (this.proxy) {
              switchLabelKey = 'enabled'
            } else {
              switchLabelKey = 'disabled'
            }
            result.outline = true
            result.label = this.getTranslate(`commons.labels.${switchLabelKey}`)
            break
          }
          case components.select: {
            if (!result.label) {
              result.label = this.getTranslate(`${options.serviceName}.labels.notChosen`)
            }
          }
          case components.textarea:
          case components['text-field']: {
            result.dense = true
            result.clearable = true
            result.details = false
            if (item.field) {
              result.mode = labelModes.outline
            }
            if (!result.label) {
              result.label = this.getTranslate(`${options.serviceName}.labels.notSet`)
            }
            break
          }
        }

        return merge(result, item.props)
      },

      getComponentEventHandlers(item) {
        return {
          input: event => {
            if (item.field) {
              this.proxy[item.field] = event
            } else {
              this.proxy = event
            }
          }
        }
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
